import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <div>
            <footer className="footer-item">
                <h5>Copyright &copy; 2021  <span className="footer-txt"> Tour Jackpot</span> All Rights Reserved.</h5>
            </footer >
        </div>
    );
};

export default Footer;